import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import supabase from '../supabase-client'
import { Button } from '@/components/ui/button'

export default function Header({ user, onLogout, subtitle = "Mushroom Farm Management" }) {
  const [loading, setLoading] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const navigate = useNavigate()

  const handleLogout = async () => {
    setLoading(true)
    await supabase.auth.signOut()
    onLogout()
    setLoading(false)
  }

  return (
    <header className="h-14 sm:h-16 flex items-center justify-between border-b bg-card px-3 sm:px-6 shadow-sm relative">
      {/* Logo and title - compact on mobile */}
      <div className="flex items-center gap-2 sm:gap-3">
        <img src="/odinlogo.png" alt="Odin Logo" className="w-10 h-10 sm:w-16 sm:h-16 object-contain" />
        <div className="flex flex-col">
          <h1 className="text-base sm:text-lg font-semibold text-foreground">Odin</h1>
          <span className="text-xs sm:text-sm text-muted-foreground hidden sm:block">{subtitle}</span>
        </div>
      </div>

      {/* Desktop navigation */}
      <div className="ml-auto hidden sm:flex items-center gap-3">
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate('/settings')}
        >
          ⚙️ Settings
        </Button>
        <span className="text-sm text-muted-foreground hidden md:inline">Welcome, {user?.email}</span>
        <Button
          variant="destructive"
          size="sm"
          onClick={handleLogout}
          disabled={loading}
        >
          {loading ? 'Signing out...' : 'Sign out'}
        </Button>
      </div>

      {/* Mobile hamburger menu button */}
      <button
        className="sm:hidden p-2 rounded-md hover:bg-muted focus:outline-none focus:ring-2 focus:ring-ring"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle menu"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {mobileMenuOpen ? (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          )}
        </svg>
      </button>

      {/* Mobile dropdown menu */}
      {mobileMenuOpen && (
        <div className="absolute top-full left-0 right-0 bg-card border-b shadow-lg sm:hidden z-50">
          <div className="flex flex-col p-3 gap-2">
            <span className="text-xs text-muted-foreground px-2 truncate">{user?.email}</span>
            <Button
              variant="outline"
              size="sm"
              className="w-full justify-start"
              onClick={() => {
                navigate('/settings')
                setMobileMenuOpen(false)
              }}
            >
              ⚙️ Settings
            </Button>
            <Button
              variant="destructive"
              size="sm"
              className="w-full justify-start"
              onClick={handleLogout}
              disabled={loading}
            >
              {loading ? 'Signing out...' : 'Sign out'}
            </Button>
          </div>
        </div>
      )}
    </header>
  )
}